import { createSlice } from "@reduxjs/toolkit";

const elasticitiesSlice = createSlice({
  name: "elasticities",
  initialState: { tuples: {} },
  reducers: {
    setTupleData: (state, action) => {
      return {
        ...state,
        tuples: {
          ...state.tuples,
          ...action.payload,
        },
      };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = elasticitiesSlice;

// Extract and export each action creator by name
export const { setTupleData } = actions;

// Export the reducer, either as a default or named export
export default reducer;
